module.exports = "https://r.zoocdn.com/_next/static/images/favicon-16x16-e993f61b9ec476b38aadeaf87acaa7a2.png";